import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PageHeader, Panel } from "@/components/admin/shared";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Database, RefreshCw, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);

  const reseed = async () => {
    setBusy(true);
    try { await api.post("/seed/demo"); toast.success("Demo data regenerated"); } catch { toast.error("Failed"); } finally { setBusy(false); }
  };
  const clearDemo = async () => {
    setBusy(true);
    try { await api.delete("/seed/demo"); toast.success("Demo data cleared — only real registrations remain"); } catch { toast.error("Failed"); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Facility Settings" subtitle="Manage your Oneiros Varachha branch & data" />

      <div className="grid lg:grid-cols-2 gap-5">
        <Panel title="Your Account">
          <div className="flex items-center gap-4">
            {user?.picture ? <img src={user.picture} alt="" className="w-14 h-14 rounded-2xl" /> : <div className="w-14 h-14 rounded-2xl bg-[#081226] text-[#E8752A] flex items-center justify-center font-display font-bold text-xl">{user?.name?.[0]}</div>}
            <div><p className="font-display font-bold text-[#081226] text-lg">{user?.name}</p><p className="text-sm text-slate-500">{user?.email}</p><span className="text-xs font-bold text-[#B8860B]">{user?.role}</span></div>
          </div>
        </Panel>

        <Panel title="Branch">
          <div className="flex items-center gap-3">
            <Building2 className="text-[#E8752A]" />
            <div><p className="font-semibold text-[#081226]">Oneiros Varachha — Main</p><p className="text-sm text-slate-500">Varachha, Surat, Gujarat</p></div>
          </div>
          <p className="text-xs text-slate-400 mt-4">The system is multi-branch ready. Additional branches can be added without rebuilding.</p>
        </Panel>

        <Panel title="Demo Data" className="lg:col-span-2">
          <div className="flex items-start gap-3 bg-amber-50 border border-amber-100 rounded-xl p-4 mb-4">
            <AlertTriangle size={18} className="text-amber-500 mt-0.5" />
            <p className="text-sm text-amber-800">Demo/sample data is flagged separately from real registrations. Clearing demo data keeps all genuine visitor registrations intact.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button onClick={reseed} disabled={busy} data-testid="reseed-btn" className="h-10 rounded-xl bg-[#081226] hover:bg-[#0f2042]"><RefreshCw size={15} className={busy ? "animate-spin" : ""} /> Regenerate Demo Data</Button>
            <Button onClick={clearDemo} disabled={busy} data-testid="clear-demo-btn" variant="outline" className="h-10 rounded-xl border-rose-200 text-rose-600 hover:bg-rose-50"><Database size={15} /> Clear Demo Data</Button>
          </div>
        </Panel>
      </div>
    </div>
  );
}
